/**
 * Simple image but it will set placeholder image to src if provided src doesn't exist
 */
import React from 'react';
import { Box, styled, useTheme } from '@mui/material';

const Image = styled('img')`
  max-width: ${(props) => props['max-width'] || '100%'};
  max-height: ${(props) => props['max-height'] || '350px'};
`;

function AppImage({ src, placeholderPath, ...rest }) {
  const theme = useTheme();
  const [error, setError] = React.useState(null);
  const defaultImage = placeholderPath || theme.body?.imagePlaceholder;

  return (
    <Box display="flex" alignItems="center" justifyContent="center" height="100%">
      <Image src={error ? defaultImage : src || defaultImage} onError={() => setError(true)} {...rest} />
    </Box>
  );
}

export default AppImage;
